import { Block, Flex, Typography, useModal } from '@aloft/toolkit-sui';

import { ValuationTablePropertyHeaderMenu } from './ValuationTablePropertyHeaderMenu.js';
import { ValuationTablePropertyHeaderProps } from './types.js';

export const ValuationTablePropertyHeaderFirstLine = ({
  title,
  titleSecondary,
  handleLeftButtonClick,
  handleRightButtonClick,
  removeComp,
}: ValuationTablePropertyHeaderProps) => {
  const DeleteConfirmationModal = useModal();

  const hasHeaderActions = [removeComp, handleLeftButtonClick, handleRightButtonClick].some(
    (act) => act !== undefined,
  );

  return (
    <Flex width="100%" alignItems="center" gap={'6px'}>
      <Block flexShrink={1} overflow="hidden">
        <Typography variant="h3" __dangerDoNotUseSx={{ fontSize: '14px' }} truncate>
          {title}
        </Typography>
      </Block>
      <Block flexGrow={1}>
        <Typography variant="body2">{titleSecondary ?? ''}</Typography>
      </Block>
      <Flex flexDirection="row" alignContent={'center'}>
        {hasHeaderActions && (
          <ValuationTablePropertyHeaderMenu
            handleLeftButtonClick={handleLeftButtonClick}
            handleRightButtonClick={handleRightButtonClick}
            DeleteConfirmationModal={DeleteConfirmationModal}
          />
        )}
      </Flex>
      {removeComp && (
        <DeleteConfirmationModal.Modal
          size="lg"
          isOpen={DeleteConfirmationModal.isModalOpen}
          onClose={DeleteConfirmationModal.closeModal}
          closeOnEsc
          title={`Delete ${title}`}
          primaryAction={{
            id: 'delete-comp-btn',
            text: 'Delete',
            onClick: () => {
              removeComp();
              DeleteConfirmationModal.closeModal();
            },
          }}
          secondaryAction={{
            text: 'Cancel',
            onClick: DeleteConfirmationModal.closeModal,
          }}
        >
          Deleting {title} cannot be undone. Any work on {title} will be lost.
        </DeleteConfirmationModal.Modal>
      )}
    </Flex>
  );
};
